const wowApp = require('angular').module('wowApp.common');

wowApp.directive('olyButton', ['$compile', 'MoveFocus', require('./button-directive')]);

wowApp.directive('olyBackButton', ['$window', '$state', '$timeout', require('./back-button-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/button/index.js
 **/